export const getImageVariant = ({ coverPicture, coverPictureNarrow, coverPictureWide, disableCoverPicture, showContent, }) => {
    const coverPictureUrls = {
        l: (showContent ? coverPicture : coverPictureWide) || coverPicture,
        m: (showContent ? coverPictureNarrow : coverPictureWide) || coverPicture,
        s: coverPicture,
        xl: (showContent ? coverPicture : coverPictureWide) || coverPicture,
    };
    const showPicture = Boolean(!disableCoverPicture &&
        (coverPicture || coverPictureNarrow || coverPictureWide));
    return {
        coverPictureUrls,
        showPicture,
    };
};
//# sourceMappingURL=getImageVariant.js.map